import IFormPostHandler from './IFormPostHandler';
import ScreenReaderLoadingMessages from '../utils/screen-reader/ScreenReaderLoadingMessages';
import announce from '../utils/screen-reader/announce';

export default class ApplePayValidationBypassFormPostHandler implements IFormPostHandler {
  async post() {
    announce(ScreenReaderLoadingMessages.Start);

    return {
      validationResult: {
        isValid: true,
        validationResults: [],
      },
    };
  }
}
